import {
  Content,
  ContentHeader,
  PageWithHeader,
  SupportButton,

  OverflowTooltip,

  Link,
} from '@backstage/core-components';

import { EntityListProvider } from '@backstage/plugin-catalog-react';
import React from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { capitalize, LinearProgress } from '@material-ui/core';
import useAsync from 'react-use/lib/useAsync';
import { Table, Logos } from '@internal/plugin-components-react';
import { makeStyles } from '@material-ui/core';
import {

  clusterManagementApiRef,
} from '@internal/plugin-cluster-management/src/api/types';

const useStyles = makeStyles({
  project: {
    '& svg, & > div': {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginRight: '8px',
    },
  },
});

const columns = [
  {
    title: 'Component',
    field: 'application_id',
    width: '30%',
    highlight: true,
    render: ({ application_id: applicationId }) => {
      return (
        React.createElement(Link, { to: `/cluster-management/applications/${applicationId}`,}
          , React.createElement(OverflowTooltip, { text: applicationId,} )
        )
      );
    },
  },
  {
    title: 'Project',
    field: 'project_name',
    width: '30%',
    render: ({ project_name: projectName }) => {
      const getProjectLogo = (name) => {
        if (/^justice/.test(name)) {
          return React.createElement(Logos.AccelByteLogoSquare, null );
        }
        if (/^foundation/.test(name)) {
          return React.createElement(Logos.FoundationsLogoSquare, null );
        }
        if (/^blackbox/.test(name) || /^avengers/.test(name)) {
          return React.createElement(Logos.BlackboxLogoSquare, null );
        }

        return null;
      };

      const classes = useStyles();

      return (
        React.createElement('div', { className: classes.project,}
          , getProjectLogo(projectName)
          , React.createElement(OverflowTooltip, { text: capitalize(projectName),} )
        )
      );
    },
  },
];

const filters = [
  {
    column: 'Component',
    type: 'select',
  },
  {
    column: 'Project',
    type: 'select',
  },
  // Temporarily hide type filter until the API is ready
  // {
  //   column: 'Type',
  //   type: 'select',
  // },
];

const displayTableData = (applications) =>
  applications.map(application => ({
    ...application,
    application_id: application.application_id,
    project_name: application.project_name,
    type: application.type,
  }));

export const AppManagementPage = ({}) => {
  const clusterManagementApi = useApi(clusterManagementApiRef);

  const { value: applicationRes, loading: isFetchingApplicationRes } = useAsync(
    async () => clusterManagementApi.getApplications(),
    [],
  );

  return (
    React.createElement(PageWithHeader, {
      title: "Application Management" ,
      subtitle: "Manage AccelByte and Client Services"    ,
      themeId: "home",}
    
      , React.createElement(EntityListProvider, null
        , React.createElement(Content, null
          , isFetchingApplicationRes && React.createElement(LinearProgress, { color: "secondary",} )
          , applicationRes?.data && applicationRes?.data?.length > 0 && (
            React.createElement(React.Fragment, null
              , React.createElement(ContentHeader, { title: "Applications",}
                , React.createElement(SupportButton, null, "All your applications"  )
              )
              , React.createElement(Table, {
                options: {
                  pageSize: 20,
                },
                columns: columns,
                filters: filters,
                data: displayTableData(applicationRes.data),}
              )
            )
          )
        )
      )
    )
  );
};
